import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableRow,
} from '@mui/material'
import { AdjudicateClaimResponse } from '../../../services/models/adjudication'
import CollapsableDataPanel from '../../CollapsableDataPanel'
import { DataTable } from '../../DataTable'
import { renderTitle } from './AdjudicateClaimResultsDialog'

interface ServiceLineDialogProps {
    open: boolean
    onClose: () => void
    data?: AdjudicateClaimResponse
}

const ServiceLineDialog = (props: ServiceLineDialogProps) => {
    const { open, onClose, data } = props

    return (
        <Dialog open={open} PaperProps={{ sx: { height: '100%' } }}>
            <DialogTitle>{`Service Results for Claim #${data?.claimNumber}`}</DialogTitle>
            <DialogContent>
                <Stack spacing={4} sx={{ overflowY: 'auto' }}>
                    {data?.results?.map((service) => (
                        <CollapsableDataPanel
                            key={service.serviceLine}
                            title={renderTitle(`Service Line ${service.serviceLine}`)}
                            content={
                                <DataTable
                                    isPrivateDataAvailable={false}
                                    data={[
                                        {
                                            key: 'CPT Code',
                                            value: service.cptCode,
                                            private: false,
                                        },
                                        {
                                            key: 'Eligible',
                                            value: service.memberIsEligible ? 'Yes' : 'No',
                                            private: false,
                                        },
                                        {
                                            key: 'Accumulator',
                                            value: (
                                                <Table>
                                                    <TableBody>
                                                        {Object.keys(
                                                            service.updatedAccumulators,
                                                        ).map((memberAndCpt) => (
                                                            <TableRow
                                                                key={memberAndCpt}
                                                                sx={{
                                                                    '& > *': {
                                                                        borderBottom: 'unset',
                                                                    },
                                                                }}
                                                            >
                                                                <TableCell
                                                                    sx={{
                                                                        paddingLeft: 0,
                                                                        borderBottom: 'none',
                                                                    }}
                                                                >
                                                                    {memberAndCpt}
                                                                </TableCell>
                                                                <TableCell>
                                                                    {
                                                                        service.updatedAccumulators[
                                                                            memberAndCpt
                                                                        ].value
                                                                    }
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            ),
                                            private: false,
                                        },
                                        {
                                            key: 'Charged Amount',
                                            value: service.chargedAmount.toString(),
                                            private: false,
                                        },
                                        {
                                            key: 'To Remit',
                                            value: service.remittanceAmount.toString(),
                                            private: false,
                                        },
                                    ]}
                                />
                            }
                        />
                    ))}
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button
                    disableElevation={true}
                    variant="contained"
                    style={{ minWidth: '120px' }}
                    onClick={onClose}
                >
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ServiceLineDialog
